/**
 * @generated SignedSource<<c9b06ebe71c203bff0852fe6a02d0468>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CompanionCareModality = "PROFESSIONAL_COACHING" | "THERAPY";
export type ThreadType = "WELLBEING" | "WORK";
export type ChatContextPopularTopicsMutation$variables = {
  careModality: CompanionCareModality;
  from: string;
  message: string;
  threadType?: ThreadType | null | undefined;
  userId: string;
};
export type ChatContextPopularTopicsMutation$data = {
  readonly createThread: {
    readonly __typename: "ThreadCreated";
    readonly chatChannelUrl: string;
    readonly threadId: string;
    readonly threadTitle: string | null | undefined;
    readonly threadType: ThreadType;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type ChatContextPopularTopicsMutation = {
  response: ChatContextPopularTopicsMutation$data;
  variables: ChatContextPopularTopicsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "careModality"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "message"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "threadType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "careModality",
        "variableName": "careModality"
      },
      {
        "kind": "Variable",
        "name": "from",
        "variableName": "from"
      },
      {
        "kind": "Variable",
        "name": "initialMessage",
        "variableName": "message"
      },
      {
        "kind": "Variable",
        "name": "threadType",
        "variableName": "threadType"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "createThread",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threadId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threadTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threadType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chatChannelUrl",
            "storageKey": null
          }
        ],
        "type": "ThreadCreated",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatContextPopularTopicsMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ChatContextPopularTopicsMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "f9b5f90973f516e0dca0e58c8fdfb645",
    "id": null,
    "metadata": {},
    "name": "ChatContextPopularTopicsMutation",
    "operationKind": "mutation",
    "text": "mutation ChatContextPopularTopicsMutation(\n  $userId: ID!\n  $message: String!\n  $from: String!\n  $careModality: CompanionCareModality!\n  $threadType: ThreadType\n) {\n  createThread(userId: $userId, from: $from, initialMessage: $message, careModality: $careModality, threadType: $threadType) {\n    __typename\n    ... on ThreadCreated {\n      threadId\n      threadTitle\n      threadType\n      chatChannelUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "126cfb509005bc0e39fe4ecc162064f0";

export default node;
